import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay, Navigation, Pagination } from "swiper";
import "swiper/css";
import left from "../assets/icons/left.svg";
import right from "../assets/icons/right.svg";
import { GetCorporation } from "../hooks/useGetCorporation";

interface thumbnailProps {
  posters: GetCorporation["getCorporation"]["corporation"]["goods"][0]["goodPosters"];
}
export const CorpThumbnails: React.FC<thumbnailProps> = ({ posters }) => {
  // console.log(posters);
  // if (posters && posters.length === 1) {
  //   var pagination = document.getElementsByClassName(
  //     "swiper-pagination"
  //   )[0] as HTMLElement;
  //   pagination.innerHTML = "";
  //   var navigation_left = document.getElementsByClassName(
  //     "swiper-navigation-left"
  //   )[0] as HTMLElement;
  //   var navigation_right = document.getElementsByClassName(
  //     "swiper-navigation-right"
  //   )[0] as HTMLElement;
  //   navigation_left.innerHTML = "";
  //   navigation_right.innerHTML = "";
  // }

  return (
    <div className="w-full h-full ">
      <Swiper
        modules={[Pagination, Autoplay, Navigation]}
        slidesPerView={1}
        loop={true}
        autoplay={{
          delay: 3000,
          disableOnInteraction: false,
        }}
        pagination={{
          clickable: true,
          el: ".swiper-pagination",
          type: "bullets",
        }}
        navigation={{
          nextEl: ".swiper-navigation-right",
          prevEl: ".swiper-navigation-left",
        }}
        className="relative h-full"
      >
        <div className="swiper-pagination"></div>
        <div className="thumbnail-blur absolute top-0 left-0 w-full h-full z-[2]"></div>
        {posters.length > 0 &&
          posters.map((poster) => (
            <SwiperSlide key={`posters - ${poster.id}`}>
              <img
                src={String(poster?.upload?.url)}
                alt={"썸네일" + poster.id}
                className="w-full aspect-detailMain object-cover"
              />
            </SwiperSlide>
          ))}
      </Swiper>
    </div>
  );
};
